import { useState } from 'react';
import { alpha, Box, Container, Typography, useTheme } from '@mui/material';
import { LogoCard } from '@components';
import Success from './components/Success';
import RegistrationForm from './components/RegistrationForm';
import { COPY } from '../../constants';

const PublicRegistrationPage: React.FC = () => {
  const theme = useTheme();
  const clearBlue = alpha(theme.palette.info.light, 0.1);

  const [successActive, setSuccessActive] = useState<boolean>(false);
  const [registeredEmail, setRegisteredEmail] = useState('');

  const handleSubmit = (email: string) => {
    setRegisteredEmail(email);
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    setSuccessActive(true);
  };

  return (
    <>
      <Box
        component={'main'}
        sx={{
          gridArea: 'main',
          backgroundColor: clearBlue,

          // Fill at least the whole screen; nothing above sets a height for 100% to use
          minHeight: '100vh',

          boxSizing: 'border-box',
          paddingTop: '40px',
          paddingBottom: '240px'
        }}>
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {
            successActive
              ? (
                <Container maxWidth='md'>
                  <Success email={registeredEmail} />
                </Container>
              )
              : (
                <LogoCard subheader='Law Enforcement Officer OCID Registration' subHeaderComponent='h1'>
                  <RegistrationForm onSuccess={handleSubmit} />
                </LogoCard>
              )
          }
          <Typography
            variant="caption"
            sx={{
              paddingY: 1,
              color: theme.palette.grey[700]
            }}>
            {COPY.copyrightFooter}
          </Typography>
        </Container>
      </Box>
    </>
  );
};

export default PublicRegistrationPage;
